import InstallationArranging from './InstallationArranging';

export default InstallationArranging